module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('div', {
    staticClass: "title-frontMatter"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781250024572_toc01#toctitle28",
      "id": "title28"
    }
  }, [_c('span', [_vm._v("RULES OF THE GAME OF LIFE")])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('div', {
    staticClass: "p-c"
  }, [_c('span', [_vm._v("Center cell will be born.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "e9781250024572_i0022.jpg",
      "src": "e9781250024572_i0022.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('div', {
    staticClass: "p-c"
  }, [_c('span', [_vm._v("… will survive.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "e9781250024572_i0023.jpg",
      "src": "e9781250024572_i0023.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('div', {
    staticClass: "p-c"
  }, [_c('span', [_vm._v("… will die.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "e9781250024572_i0024.jpg",
      "src": "e9781250024572_i0024.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('div', {
    staticClass: "p-c"
  }, [_c('span', [_vm._v("… will die.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "e9781250024572_i0025.jpg",
      "src": "e9781250024572_i0025.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("“Life” as defined by the mathematician John Horton Conway is a digital universe consisting of two-dimensional squares, or “cells,” laid out in a grid. Each cell has exactly eight neighbors: one on each of its four sides, and one at each of its four corners. On each pass, or iteration, over the grid, the program decides the fate of each cell by applying three simple rules:")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("A cell is born (grid-point turned “on”) if it was previously “dead” (grid-point “off”) and exactly three of its neighboring cells are alive.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The cell survives (remains as it is) if it has two or three live neighbors.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("If the cell is crowded (has more than three live neighbors) or isolated (has less than two neighbors alive), it dies.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91054adc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781250024572_fm02.vue
// module id = 72
// module chunks = 0